import { EventgroupState } from './eventgroups/types';
import { ClosureState } from './closure/types';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { Action, AnyAction, combineReducers, Dispatch } from 'redux';
import { alertReducer } from './alert/reducer';
import { AlertState } from './alert/types';
import { EventReducer } from './events/reducer';
import { EventState } from './events/types';
import { LayoutReducer } from './layout/reducer';
import { LayoutState } from './layout/types';
import { ParticipantReducer } from './participant/reducer';
import { ParticipantState } from './participant/types';
import { SeasonReducer } from './season/reducer';
import { SeasonState } from './season/types';
import { sectionReducer } from './sections/reducer';
import { SectionState } from './sections/types';
import { userReducer } from './user/reducer';
import { UserState } from './user/types';
import { WeekReducer } from './weeks/reducer';
import { WeekState } from './weeks/types';
import { AuthState } from './auth/types';
import { AuthReducer } from './auth/reducer';
import { ImageState } from './image/types';
import { imageReducer } from './image/reducer';
import { ClosureReducer } from './closure/reducer';
import { EventgroupReducer } from './eventgroups/reducer';

export interface ApplicationState {
  sections: SectionState;
  alerts: AlertState;
  router: RouterState;
  season: SeasonState;
  events: EventState;
  weeks: WeekState;
  layout: LayoutState;
  users: UserState;
  parts: ParticipantState;
  auth: AuthState;
  image: ImageState;
  closure: ClosureState;
  eventgroup: EventgroupState;
}

export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>;
}

export const rootReducer = (history: History) =>
  combineReducers<ApplicationState>({
    sections: sectionReducer,
    alerts: alertReducer,
    season: SeasonReducer,
    router: connectRouter(history),
    events: EventReducer,
    weeks: WeekReducer,
    layout: LayoutReducer,
    users: userReducer,
    parts: ParticipantReducer,
    auth: AuthReducer,
    image: imageReducer,
    closure: ClosureReducer,
    eventgroup: EventgroupReducer
  });



// WEBPACK FOOTER //
// ./src/store/index.ts